export default "__VITE_ASSET__C151Xb3A__"